module.exports = __webpack_public_path__ + "static/media/the-dutch-4.81be1565.jpg";